module.exports = __webpack_public_path__ + "static/img/1.1496cae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/index/vip-banner/1.jpg
// module id = w/w9
// module chunks = 0